import { Column, Grid } from '@carbon/react'
import type { KmerLocale } from '@kmerhosting/i18n'
import { homeCopy, type HomeCopy } from '@/lib/home-i18n'

const paymentMethodsAlt = [
  'Airtel',
  'Alipay',
  'American Express',
  'Apple Pay',
  'Bitcoin',
  'Celtiis Cash',
  'Diners Club',
  'Discover',
  'Google Pay',
  'Halopesa',
  'JCB',
  'Mastercard',
  'Moov',
  'MTN MoMo',
  'Orange Money',
  'PayPal',
  'UnionPay',
  'Visa',
  'Vodacom',
  'Wave',
].join(', ')

const securePaymentIntro: Record<KmerLocale, string> = {
  en: 'Pay securely, regardless of your country or currency.',
  fr: 'Payez en toute sécurité, quel que soit votre pays ou votre devise.',
  es: 'Paga de forma segura, sin importar tu país o moneda.',
  pt: 'Pague com segurança, independentemente do seu país ou moeda.',
  de: 'Bezahlen Sie sicher, unabhängig von Ihrem Land oder Ihrer Währung.',
  'zh-Hans': '无论您所在的国家或使用的货币，都可以安全付款。',
  ar: 'ادفع بأمان بغض النظر عن بلدك أو عملتك.',
  hi: 'अपने देश या मुद्रा की परवाह किए बिना सुरक्षित रूप से भुगतान करें।',
  bn: 'আপনার দেশ বা মুদ্রা যাই হোক, নিরাপদে পেমেন্ট করুন।',
  id: 'Bayar dengan aman, apa pun negara atau mata uang Anda.',
  ja: '国や通貨に関係なく、安全にお支払いいただけます。',
  ru: 'Оплачивайте безопасно независимо от вашей страны или валюты.',
  it: 'Paga in sicurezza, indipendentemente dal tuo Paese o dalla valuta.',
  ko: '국가나 통화에 관계없이 안전하게 결제하세요.',
  tr: 'Ülkeniz veya para biriminiz ne olursa olsun güvenle ödeme yapın.',
  vi: 'Thanh toán an toàn bất kể quốc gia hay loại tiền tệ của bạn.',
  ur: 'اپنے ملک یا کرنسی سے قطع نظر محفوظ طریقے سے ادائیگی کریں۔',
  nl: 'Betaal veilig, ongeacht uw land of valuta.',
  pl: 'Płać bezpiecznie niezależnie od kraju lub waluty.',
  fa: 'صرف‌نظر از کشور یا ارز خود، با امنیت پرداخت کنید.',
}

export function PaymentMethodsStrip({
  copy = homeCopy('en'),
  locale = 'en',
}: {
  copy?: HomeCopy
  locale?: KmerLocale
} = {}) {
  return (
    <section className="payment-methods" aria-labelledby="payment-methods-title">
      <Grid>
        <Column sm={4} md={8} lg={4}>
          <p className="section-label">{copy.payments}</p>
          <h2 id="payment-methods-title" className="payment-methods__title">{copy.paymentOptions}</h2>
          <p className="payment-methods__intro">{securePaymentIntro[locale]}</p>
        </Column>
        <Column sm={4} md={8} lg={12}>
          <div className="payment-methods__logos" role="img" aria-label={paymentMethodsAlt}>
            <img
              src="/payment-logos/payment-methods-all.webp"
              alt=""
              aria-hidden="true"
              width={334}
              height={62}
            />
          </div>
        </Column>
      </Grid>
    </section>
  )
}
